import httpClient from '@api/httpClient'
import type { Location, LocationFilters } from '@models/location'
import type { PaginatedResponse } from '@models/pagination'
import { locationsUrls } from './constants'

const getLocations = async (filters: LocationFilters) => {
  const { companyId, ...params } = filters
  const { data } = await httpClient.get<PaginatedResponse<Location>>(
    locationsUrls.root(companyId),
    { params: { ...params, companyId } },
  )
  return data
}

export interface CreateLocationRequestData {
  companyId: number
  locationExternalId: string
  name: string
  address?: string | null
}

const createLocation = async ({
  companyId,
  ...props
}: CreateLocationRequestData) => {
  const { data } = await httpClient.post<Location>(
    locationsUrls.root(companyId),
    props,
  )
  return data
}

export interface UpdateLocationRequestData {
  companyId: number
  id: number
  name: string
  address?: string | null
}

const updateLocation = async ({
  companyId,
  id,
  ...props
}: UpdateLocationRequestData) => {
  const { data } = await httpClient.patch<Location>(
    locationsUrls.location(companyId, id),
    props,
  )
  return data
}

export interface DeleteLocationRequestData {
  companyId: number
  id: number
}

const deleteLocation = async ({ companyId, id }: DeleteLocationRequestData) => {
  const { data } = await httpClient.delete(
    locationsUrls.location(companyId, id),
  )
  return data
}

export default { getLocations, createLocation, updateLocation, deleteLocation }
